import StaffCreateEditComponent from 'src/components/features/superAdmin/staffCreateEditComponent';

const CreateEditStaffPage = () => <StaffCreateEditComponent />;

export default CreateEditStaffPage;
